export const dateFilter = /^[0-9]{4}-[0-9]{1,2}-[0-9]{1,2}$/;
export const brithdayDateFilter = /^[0-9]{1,2}-[0-9]{1,2}-[0-9]{4}$/;
